/* eslint-disable no-restricted-imports */
/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import {
	CLICK_PRODUCT_VIEW_SOURCE,
	CLICK_SOURCE_LIST_NAME,
} from '@/data/constants/clickProductView';
import { buildCarouselItem } from '@/data/events/data/gtm/CarouselItemListView';
import { GTMCarouselProductClickPayload } from '@/data/types/GTM';
import { findProductAttribute } from 'integration/utils/findProductAttribute';

export const getGTMCarouselProductClickEventData = async (
	payload: GTMCarouselProductClickPayload
) => {
	const { parentProduct, parentPartNumber, product, index, item_list_id } = payload;

	const item_list_name =
		CLICK_SOURCE_LIST_NAME[item_list_id as CLICK_PRODUCT_VIEW_SOURCE] ?? item_list_id;

	const item = buildCarouselItem(product, index, item_list_id, item_list_name, 'Dportenis');

	return {
		product_item_id: parentProduct?.partNumber ?? parentPartNumber ?? '',
		product_item_name: parentProduct?.name ?? '',
		familia_producto:
			(parentProduct && findProductAttribute(parentProduct.attributes, 'Familia')?.value) ?? '',
		ecommerce: {
			item_list_id,
			item_list_name,
			value: product.productPrice?.offer ?? 0,
			currency: product.productPrice?.currency ?? '',
			items: [item],
		},
	};
};
